document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.uom-c-course-search');
  if (!form) return;

  const level = form.querySelector('#study-level');
  if (!level) return;

  const fieldset = form.querySelector('fieldset');
  const radio2025 = form.querySelector('input[name="year"][value="2025"]');
  const radio2026 = form.querySelector('input[name="year"][value="2026"]');
  const radio2025Wrapper = radio2025?.closest('label.uom-c-radio');
  const radio2026Wrapper = radio2026?.closest('label.uom-c-radio');

  function updateYearRadios() {
    const isUndergrad = level.value === 'undergraduate';

    if (isUndergrad) {
      fieldset.disabled = false;
      if (radio2025Wrapper) radio2025Wrapper.style.display = '';
      if (radio2025) radio2025.disabled = false;
      if (radio2026) radio2026.disabled = false;
      if (radio2026Wrapper) radio2026Wrapper.style.display = '';

      const anyChecked = [radio2025, radio2026].some((r) => r && r.checked);
      if (!anyChecked && radio2026) radio2026.checked = true;
    } else {
      // Hide 2025, force 2026 “selected”, then disable the group (drives label greying via CSS)
      if (radio2025Wrapper) radio2025Wrapper.style.display = 'none';
      if (radio2026) radio2026.checked = true;
      if (radio2026Wrapper) radio2026Wrapper.style.display = '';

      fieldset.disabled = true; // no need to also disable each radio
    }
  }

  level.addEventListener('change', updateYearRadios);
  updateYearRadios();
});
